// extracted by mini-css-extract-plugin
module.exports = {"heroCardWrapper":"heroCardList_heroCardWrapper__A8QLX","leftCard":"heroCardList_leftCard__Gnhbj","rightCard":"heroCardList_rightCard__MvVGl"};